import { Description } from "@mui/icons-material/";
import { Box, Button, Chip, Typography } from "@mui/material";
import { GetData } from "contexts/DataContext";
import {
  dateToString,
  getCarName,
  getDateMinusTime,
  getOrderIcon,
  isIdentical,
  isObjectEmpty,
  isOrderStatusActive,
  parseRFC3339,
  translateOrderStatus,
  translateOrderType,
} from "data/functions";
import React from "react";
import { useNavigate } from "react-router-dom";

import { constants } from "data/globals";
import { OrderChip } from "data/styles/styleGlobals";

function OrderData(props) {
  const [secondPart, setSecondPart] = React.useState(false);
  const [trirdPart, setTrirdPart] = React.useState(false);

  React?.useEffect(() => {
    setSecondPart(secondPartCheck(props?.item));
    setTrirdPart(trirdPartCheck(props?.item));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.item]);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        borderRadius: "4px",
        // height: "100%",
        boxShadow:
          "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px",
        display: "flex",
        flexDirection: "column",
        margin: props?.margin ? props?.margin : "8px",
        padding: "4px",
        position: "relative",
      }}
    >
      <Box
        onClick={(e) =>
          navigate(`/orders/${props?.item.orderID}`, {
            state: {
              clientID: props?.item?.user?.id,
              orderID: props?.item?.orderID,
            },
          })
        }
        sx={{
          "&:hover": {
            backgroundColor: "rgb(0 0 0 / 2%)",
          },
          cursor: "pointer",
        }}
      >
        <OrderTitle {...props} />
        <OrderBody secondPart={secondPart} trirdPart={trirdPart} {...props} />
      </Box>
      {/* <OrderButtons trirdPart={trirdPart} {...props} /> */}
    </Box>
  );
}

function OrderTitle(props) {
  const { dataObj } = GetData();
  return (
    <Box sx={{ margin: "2px 0" }}>
      <Box
        sx={{
          alignItems: "flex-start",
          display: "flex",
          // flexDirection: dataObj?.deviceWidth?.isMobile ? "column" : "row",
          flexDirection: "row",
          flexWrap: "nowrap",
          justifyContent: dataObj?.deviceWidth?.isMobile
            ? "space-between"
            : "flex-start",
          position: "relative",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            position: "relative",
          }}
        >
          {getOrderIcon(props?.item?.type)}

          <Box
            sx={{
              alignItems: "flex-start",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {props?.item?.type && (
              <Typography
                // variant={dataObj?.deviceWidth?.isMobile ? "caption" : "body2"}
                sx={{
                  fontSize: dataObj?.deviceWidth?.isMobile
                    ? "0.87rem"
                    : "0.875rem",
                  lineHeight: "1.2",
                }}
              >
                {translateOrderType(props?.item?.type)}{" "}
                {"№" + props?.item?.docNumber}
              </Typography>
            )}
            {!isObjectEmpty(props?.item?.docDate) &&
              translateOrderType(props?.item?.type) !== constants.ruTypeZR && (
                <Typography
                  sx={{
                    fontSize: dataObj?.deviceWidth?.isMobile
                      ? "0.87rem"
                      : "0.875rem",
                    lineHeight: "1.2",
                  }}
                  // variant={dataObj?.deviceWidth?.isMobile ? "caption" : "body2"}
                >
                  {parseRFC3339(props?.item?.docDate)
                    ? "от " +
                      dateToString(parseRFC3339(props?.item?.docDate), false)
                    : ""}
                </Typography>
              )}
            {!isObjectEmpty(props?.item?.planDate) &&
              translateOrderType(props?.item?.type) === constants.ruTypeZR && (
                <Typography
                  sx={{
                    fontSize: dataObj?.deviceWidth?.isMobile
                      ? "0.87rem"
                      : "0.875rem",
                    lineHeight: "1.2",
                  }}
                  // variant={dataObj?.deviceWidth?.isMobile ? "caption" : "body2"}
                >
                  {"на " +
                    dateToString(parseRFC3339(props?.item?.planDate), true)}
                </Typography>
              )}
          </Box>
        </Box>
        <Box
          sx={{
            alignItems: "flex-end",
            display: "flex",
            flexDirection: dataObj?.deviceWidth?.isMobile ? "column" : "row",
            gap: "4px",
            marginLeft: dataObj?.deviceWidth?.isMobile ? "0" : "12px",

            // marginTop: "-12px",
          }}
        >
          {props?.item?.status && <OrderChip title={props?.item?.status} />}
          {translateOrderStatus(props?.item?.payStatus) && (
            <OrderChip title={props?.item?.payStatus} />
          )}
        </Box>
      </Box>
    </Box>
  );
}

function OrderBody(props) {
  const { dataObj } = GetData();

  const car = (dataObj.carArrWithSold ?? []).find((element) => {
    if (isIdentical(element?.car?.id, props?.item?.carID)) return true;
    return false;
  });

  return (
    <React.Fragment>
      {props?.secondPart && (
        <Box
          sx={{
            alignItems: "flex-start",
            display: "flex",
            flexDirection: "column",
            margin: "4px 0 0 4px",
          }}
        >
          {props?.item?.carID && (
            <Typography
              // variant={dataObj?.deviceWidth?.isMobile ? "caption" : "body2"}
              sx={{
                alignItems: "center",
                display: "flex",
                fontSize: dataObj?.deviceWidth?.isMobile
                  ? "0.87rem"
                  : "0.875rem",
                lineHeight: "1.2",
              }}
            >
              {car?.car?.marka?.imageUrl ? (
                <img
                  alt={"Марка"}
                  loading="lazy"
                  onError={(e) => {
                    // e.target.hidden = true;
                  }}
                  src={car?.car?.marka?.imageUrl}
                  style={{
                    margin: "0 0 0 -2px",
                    overflow: "hidden",
                    width: "24px",
                  }}
                />
              ) : undefined}

              {getCarName(
                props?.item?.carID,
                dataObj?.carArrWithSold,
                "",
                true
              )}
            </Typography>
          )}
          {!isObjectEmpty(parseRFC3339(props?.item?.planDate)) &&
            translateOrderType(props?.item?.type) === constants.ruTypeZP && (
              <Typography
                // variant={dataObj?.deviceWidth?.isMobile ? "caption" : "body2"}
                sx={{
                  fontSize: dataObj?.deviceWidth?.isMobile
                    ? "0.87rem"
                    : "0.875rem",
                  lineHeight: "1.2",
                }}
              >
                {"Срок поставки: " +
                  dateToString(parseRFC3339(props?.item?.planDate), false)}
              </Typography>
            )}

          {parseInt(props?.item?.docSum?.total) > 0 && (
            <Typography
              // variant={dataObj?.deviceWidth?.isMobile ? "caption" : "body2"}
              sx={{
                fontSize: dataObj?.deviceWidth?.isMobile
                  ? "0.87rem"
                  : "0.875rem",
                lineHeight: "1.2",
              }}
            >
              Сумма:{" "}
              {props?.item?.docSum?.total +
                (props?.item?.currencyName
                  ? " " + props?.item?.currencyName
                  : " руб.")}
            </Typography>
          )}
        </Box>
      )}
    </React.Fragment>
  );
}

function OrderButtons(props) {
  return (
    <React.Fragment>
      {props?.trirdPart && (
        <Box>
          {parseRFC3339(props?.item?.docDate) > getDateMinusTime(3) &&
            !isOrderStatusActive(props?.item?.status) && (
              <Button
                onClick={() => {
                  props?.setOpenR(true);
                }}
                size="small"
                sx={{
                  margin: "4px",
                  padding: "0px 0.4rem",
                  textTransform: "none",
                }}
                variant="outlined"
              >
                Оценить
              </Button>
            )}
          {!isObjectEmpty(props?.item?.payDebt) && (
            <Button
              size="small"
              sx={{
                margin: "4px",
                padding: "0px 0.4rem",
                textTransform: "none",
              }}
              variant="outlined"
            >
              Оплатить
            </Button>
          )}
        </Box>
      )}
    </React.Fragment>
  );
}

export function OrderBlock(props) {
  const [openR, setOpenR] = React.useState(false);

  return (
    <React.Fragment>
      <Box key={props?.index} sx={{ width: "100%" }}>
        <OrderData {...props} setOpenR={setOpenR} />
      </Box>
    </React.Fragment>
  );
}

function secondPartCheck(item) {
  if (item?.carID || parseInt(item?.docSum?.total) > 0) {
    return true;
  } else {
    return false;
  }
}

function trirdPartCheck(item) {
  if (
    (parseRFC3339(item?.docDate) > getDateMinusTime(3) &&
      !isOrderStatusActive(item?.status)) ||
    parseInt(!isObjectEmpty(item?.payDebt)) > 0
  ) {
    return true;
  } else {
    return false;
  }
}
